import * as R from "ramda";
import { Col, Input, Row, Spin, Tabs } from "antd";
import React, { useEffect, useState } from "react";

import { getFileContent } from "../aliyun-service-api";
import {
  useRawData,
  BaseInfoCard,
} from "@/containers/Video/widgets/base-type-carousel-item-video";
import { replaceHttpToHttps } from "./base-type-carousel-item-image";

const { TabPane } = Tabs;

export const BaseTypeCarouselItemText = (props) => {
  const { rawData, loading } = useRawData(props);

  const textUrl = replaceHttpToHttps(R.pathOr(
    "",
    ["aliyuninfo", "MediaBasicInfo", "InputURL"],
    rawData
  ));

  const [content, setContent] = useState("");

  useEffect(() => {
    if (!textUrl) {
      return;
    }
    getFileContent(textUrl).then((res) => {
      setContent(res);
    });
  }, [textUrl]);

  if (loading) {
    return <Spin />;
  }

  return (
    <Row
      gutter={16}
      style={{
        maxHeight: "calc(100% - 40px)",
        padding: 20,
      }}
    >
      <Col span={16}>
        <Input.TextArea rows={50} value={content} />
      </Col>
      <Col span={8}>
        <Tabs defaultActiveKey="1" type="card" className="bg-white h-full">
          <TabPane tab="详情" key="1">
            <BaseInfoCard rawData={rawData} {...props} />
          </TabPane>
        </Tabs>
      </Col>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/base-type-carousel-item-text.js